import React from 'react'
import { Cookies } from 'react-cookie'

// Drop-in replacement for react-cookie's own withCookies HOC, which injects the same
// `cookies` prop but logs
//   "Cannot update during an existing state transition (such as within `render`)"
// on every render after a cookie has been written.
//
// react-cookie 6.1.3 CookieWrapper.render() calls cookies.getAll() without the
// { doNotUpdate: true } flag, so universal-cookie re-parses document.cookie, notices
// the change and synchronously fires its change listeners - one of which is the same
// CookieWrapper's forceUpdate(). React sees an update scheduled mid-render. Their
// useCookies hook passes doNotUpdate for exactly this reason; the class HOC does not.
//
// The wrapped containers only get() and set() cookies and keep their own state in
// sync, so none of the HOC's re-render-on-change machinery is needed here. A shared
// instance is enough: Cookies reads and writes document.cookie directly, so it stays
// consistent with the CookiesProvider instance used elsewhere.
const cookies = new Cookies()

const withCookies = (WrappedComponent) => {
  const WithCookies = (props) => <WrappedComponent {...props} cookies={cookies} />
  WithCookies.displayName = `withCookies(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`
  return WithCookies
}

export default withCookies
